
import _ from 'lodash'
import { commonfunc } from '~/mixin/common'
import { isShowTotalSelling } from '~/config/options'
import { ugMixin } from '~/mixin/ug/ugMixin'
import CommonImage from '~/components/common/CommonImage.vue'
import CommonVideo from '~/components/common/CommonVideo.vue'

export default {
  name: 'CtenUnitCmp',
  components: {
    CommonVideo,
    CommonImage
  },
  mixins: [commonfunc, ugMixin],
  props: {
    item: { // 상품 데이터
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    idx: { // 상품 index
      type: Number
    },
    unitType: { // 상품 type
      type: String,
      default: 'general'
    },
    listGroup: { // 그룹 상품리스트 사용 여부
      type: Boolean,
      default: false
    },
    review: { // 리뷰 유닛
      type: Boolean,
      default: false
    },
    quantity: { // 수량 노출
      type: Boolean,
      default: false
    },
    close: { // 닫기 버튼 기능
      type: Boolean,
      default: false
    },
    cart: { // 장바구니 버튼 노출/비노출 여부
      type: Boolean,
      default: true
    },
    radio: { // 라디오 선택
      type: Boolean,
      default: false
    },
    contwriter: { // 사용자 등록 상품 type
      type: Boolean,
      default: false
    },
    ranking: { // 링킹 유닛
      type: Boolean,
      default: false
    },
    typeList: { // 리스트 타입
      type: Boolean,
      default: false
    },
    order: { // (메뉴)주문에서만 사용 - 가격 우측 정렬 등
      type: Boolean,
      default: false
    },
    long: { // long type veideo
      type: Boolean,
      default: false
    },
    noVisible: { // 좋아요 비노출
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isShowTotalSelling,
      linkKey: 0,
      check: false,
      num: 0, // 수량
      swiperOpt: { // 묶음상품 swiper options
        slidesPerView: 4,
        loop: false,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      newSwiperOpt: { // 신상품 swiper options
        slidesPerView: 3,
        loop: false,
        spaceBetween: 28,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-progress',
          type: 'progressbar'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planBoxSwiperOpt: { // 기획전 (신상품) 박스형 swiper options
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planSwiperOpt: { // 기획전 (신상품) 리스트형 swiper options
        slidesPerView: 2,
        loop: false,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true, // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      }
    }
  },
  computed: {
    reviewNum () { // 23.08.25 수정
      if (typeof this.item.reviewNum === 'number') {
        if (this.item.reviewNum > 9999 && this.item.reviewNum <= 99999) {
          return '9.9+ 천'
        } else if (this.item.reviewNum > 99999) {
          return '99.9+ 만'
        } else {
          return Number(this.item.reviewNum).toLocaleString('ko-KR')
        }
      } else if (this.item.reviewNum === 'string') {
        if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 9999 && Number(this.item.reviewNum.replace(/[^0-9]/g, '')) <= 99999) {
          return '9,9+ 천'
        } else if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 99999) {
          return '99,9+ 만'
        }
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    total () { // 23.08.25 수정
      if (typeof this.item.total === 'number') {
        if (this.item.total > 9999 && this.item.total <= 99999) {
          return '9.9+ 천'
        } else if (this.item.total > 99999) {
          return '99.9+ 만'
        } else {
          return Number(this.item.total).toLocaleString('ko-KR')
        }
      } else if (typeof this.item.total === 'string') {
        if (Number(this.item.total.replace(/[^0-9]/g, '')) > 9999 && Number(this.item.total.replace(/[^0-9]/g, '')) <= 99999) {
          return '9.9+ 천'
        } else if (Number(this.item.total.replace(/[^0-9]/g, '')) > 99999) {
          return '99.9+ 만'
        }
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    prodPrice () {
      if (typeof this.item.price === 'number') {
        return Number(this.item.price).toLocaleString('ko-KR')
      } else {
        return Number(this.item.price.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    rankFlag () {
      if (typeof this.item.ranking.variance === 'number') {
        if (this.item.ranking.variance === 0) { // 변동없음
          return ''
        } else { // up & down
          return Math.abs(this.item.ranking.variance)
        }
      } else {
        return 'new'
      }
    },
  },
  watch: {
  },
  created () {
    this.check = this.item.isZzim === 'Y'
  },
  mounted () {
    if (document.querySelectorAll('.goods-list.ugc.masonry').length > 0) {
      this.unitHeight()
    }
  },
  unmounted () {
  },
  methods: {
    isNotEmpty (obj) {
      return (obj !== null && typeof obj !== 'undefined' && obj !== '')
    },
    // 숫자 표기(만, 억단위로 표시하고 백의 자리에서 반올림)
    displayformatNumber (num) {
      if (num === null) {
        return '0'
      }
      if (typeof num === 'string') {
        num = Number(num)
      }

      if (num < 10000) {
        return num.toLocaleString('ko-KR')
      }

      let str = ''

      // 반올림하여 억/만으로 표시하여 리턴

      if (num < 1000000) {
        let mok = num / 10000

        mok = Math.round(mok * 10) / 10

        str = String(mok) + '만'
      } else {
        str = '99.9+만'
        // let mok = num / 100000000
        // mok = Math.round(mok * 10) / 10
        // str = String(mok) + '억'
      }

      return str
    },
    playVideo () {
      // this.$refs.videoPlayer.play()
    },
    pauseVideo () {
      // this.$refs.videoPlayer.pause()
    },
    getCtenLink (ctenInfo) {
      let movePath = ''
      if (ctenInfo.ctenTyCd === '01') {
        movePath = '/ug/ugd/SCR_UGD_0007'
      } else if (ctenInfo.ctenTyCd === '02') {
        movePath = '/ug/ugd/SCR_UGD_0014'
      } else {
        movePath = '/ug/ugd/SCR_UGD_0019'
      }
      return movePath
    },
    beforeMoveDtl (ctenId) {
      this.$emit('saveFilter', ctenId)
    },
    prodNum (e) {
      if (typeof e === 'number') {
        if (e > 99999) {
          return '99,999+'
        } else {
          return Number(e).toLocaleString('ko-KR')
        }
      } else if (Number(e.replace(/[^0-9]/g, '')) > 99999) {
        return '99,999+'
      } else {
        return Number(e.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    toggleChk (event) {
      this.$emit('toggle-chk', {
        id: event.ctenId,
        checked: event.chk
      })
    },
    alarmChk (event) {
      this.$emit('alarm-chk', {
        id: event.ctenId,
        checked: event.chk
      })
    },
    newAlarmChk (event) {
      this.$emit('alarm-chk', {
        prodId: event.prodId,
        id: event.ctenId,
        checked: event.chk
      })
    },
    unitHeight () {
      document.querySelectorAll('.goods-list.ugc.masonry > .goods-unit').forEach((el) => {
        // console.log(el.clientHeight)
        el.style.cssText = 'grid-row-end: span ' + (el.clientHeight + 0)
      })
    },
    prodClose (event) {
      this.$emit('prod-close', event)
    },
    loginAlert () {
      this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
    },
    updScrap (item, ev) {
      const act = {
        ctenId: item.ctenId,
        lgnMbMngNo: this.$store.getters['session/getMbMngNo'],
        avtTy: 'S'
      }

      if (_.isEmpty(act.lgnMbMngNo)) {
        this.check = false
        this.loginAlert()
      } else {
        if (item.isZzim === 'Y') {
          item.isZzim = 'N'
          act.zzimActTy = 'M'
        } else {
          item.isZzim = 'Y'
          act.zzimActTy = 'P'
        }

        console.log('act=', act)

        this.$AxiosBuilder
          .data(act)
          .build()
          .post('/ug/common/updCtenZzim')
          .then((res) => {
            if ((!res.data.data.success && res.data.data.returnCode === '-1')) {
              this.check = false
              this.$confirm(this.$t('UG.REG_PROFILE_FOR_SCRAP'), { center: true, dangerouslyUseHTMLString: true }).then(() => {
                this.$router.push({ name: 'ug-ugp-SCR_UGP_0018', params: { returnUrl: this.$route.fullPath } })
              }).catch(() => {
                return false
              })
            } else if (!res.data.success) {
              this.check = false
            } else if (act.avtTy === 'S') {
              if (act.zzimActTy === 'P') {
                this.check = true
                this.openToast(this.$t('UG.SCRAP_SUCCESS'))
              } else {
                this.check = false
                this.openToast(this.$t('UG.SCRAP_CANCEL'))
              }
            }
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    openToast (msg) {
      this.$notify({
        // title: 'Custom Position',
        message: msg,
        position: 'center',
        showClose: false,
        duration: 3000,
        onClick: () => { this.$notify.closeAll() }
      })
    },
    videoOptions () {
      return {
        playsinline: true,
        loop: true,
        muted: true,
        preload: 'metadata'
      }
    }
  }
}
